// extracted by mini-css-extract-plugin
export var button = "MerchLandingPage-module__button___HaJjJ";
export var cancel = "MerchLandingPage-module__cancel___vgJtd";
export var content = "MerchLandingPage-module__content___aBqSX";
export var copy = "MerchLandingPage-module__copy___aIQhI";
export var desktopDisclaimer = "MerchLandingPage-module__desktopDisclaimer___vPG9f";
export var features = "MerchLandingPage-module__features___UimnU";
export var hero = "MerchLandingPage-module__hero___M3L5p";
export var link = "MerchLandingPage-module__link___OWXsA";
export var logoDesktop = "MerchLandingPage-module__logoDesktop___AzONq";
export var logoMobile = "MerchLandingPage-module__logoMobile___ThOUU";
export var lottie = "MerchLandingPage-module__lottie___e_zZg";
export var mobileDisclaimer = "MerchLandingPage-module__mobileDisclaimer___oKA5Z";
export var picture = "MerchLandingPage-module__picture____jeQi";
export var step = "MerchLandingPage-module__step___CA8wX";
export var steps = "MerchLandingPage-module__steps___lMGhp";
export var stepsHeader = "MerchLandingPage-module__stepsHeader___iQyWz";
export var subhead = "MerchLandingPage-module__subhead___dWgl0";
export var texture = "MerchLandingPage-module__texture___pEkHI";
export var title = "MerchLandingPage-module__title___w9ZXs";
export var wrapper = "MerchLandingPage-module__wrapper___VOCaw";